// inspired by: https://www.stefanjudis.com/snippets/how-trigger-file-downloads-with-javascript/

export default {
  mounted() {
    this.handleEvent('trigger-download', ({ target, url, newTab }) => {
      if (target !== this.el.id) return

      this.downloadFile(url, newTab)
    })
  },

  downloadFile(url, newTab = false) {
    // Create a invisble-to-the-user link
    const link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.download = url.split('/').pop()

    if (newTab) link.target = '_blank'
    // LV detects clicks to external sites and will disconnect the liveSocket when this happens. To stop this
    // when opening a download in the current tab we call the following: "event.stopImmediatePropagation()"
    // source: https://github.com/phoenixframework/phoenix_live_view/issues/2394#issuecomment-1382878318
    //
    // NOTE: we don't want to open some downloads in a separate browser tab so the visual interaction is nice
    // and not bouncing around between tabs - compressed files for example. PDF downloads we do want to open in
    // a separate tab so the browser can render them.
    else link.onclick = (event) => event.stopImmediatePropagation()

    // It needs to be added to the DOM so it can be clicked
    document.body.appendChild(link)
    link.click()

    // To make this work on Firefox we need to wait a little while before removing it.
    setTimeout(() => {
      URL.revokeObjectURL(link.href)
      link.parentNode.removeChild(link)
    }, 0)

    this.pushEvent('download.downloading', {})
  }
}
